module.exports = __webpack_public_path__ + "static/media/DBBlack.9f1ccff2.svg";